export default "__VITE_ASSET__Dqz8o0TR__"